module.exports = __webpack_public_path__ + "media/images/press_kit/norwegian_cruise_line_holdings/login/3_oceania-2495b7f63b6ef83182e99f1601fb80d8.png";